import React from 'react'

const OverviewFilter = ({ selectedFilter, setSelectedFilter }) => {
  return (
    <div className="bg-white dark:bg-dark  border dark:border-border-dark dark:text-white px-4 py-4 transition-all duration-300 flex flex-row items-center justify-between rounded-lg">
      <div className='flex flex-row items-center divide-x divide-gray-200 rounded-md overflow-hidden border border-gray-300 dark:border-border-dark dark:bg-dark bg-white'>
        {[
          "Overview",
          "Other Statistics",
        ].map((filter, index) => (
          <button key={index}
            className={`${selectedFilter === filter ? "bg-white dark:bg-secondaryDark font-semibold" : "dark:bg-dark"}  px-4 py-2 text-sm  transition-all pointer-cursor duration-300 hover:bg-gray-50 dark:bg-dark dark:text-white text-black`} onClick={() => setSelectedFilter(filter)}>
            {filter}
          </button>
        ))}
      </div>

      <div></div>
    </div>
  )
}

export default OverviewFilter